<template>
  <div class="n-forms-chart html2pdf__page-break">
    <head-line>
      {{$ml.get('n-forms chart')}}
    </head-line>

    <div class="chart-cnt">
      <DoughnutChart 
        class="doughnut-chart" 
        :chart-data="chartData" 
        :options="options"
      />
    </div>
  </div>
</template>

<script>
import DoughnutChart from './../common/DoughnutChart'

export default {
  data() {
    return {
      options: {
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              callback: (value, index, values) => {
                return this.$levelToInterpretation(value);
              }
            }
          }]
        }
      }
    }
  },
  methods: {
    
  },
  components: {
    DoughnutChart,
  },
  computed: {
    section() {
      return this.$root.data.waterTest;
    },
    dataSets() {
      return [
        {
          data: [
            this.section.data.data.values['NO3_Val'],
            this.section.data.data.values['NH4_Val'],
          ],
          backgroundColor: [ '#3498db', '#1abc9c' ],
        },
      ]
    },
    chartData() {
      return {
        labels: [
          'NNO3',
          'NNH4',
        ],
        datasets: this.dataSets,
      }
    }
  },
}
</script>

<style lang="scss" scoped>

::v-deep {
  .doughnut-chart {
    width: 100%;
    max-width: 500px;
  }
}

.n-forms-chart {

  .chart-cnt {
    width: 100%;
    padding-top: 50px;

    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

</style>
